import { useCallback, useMemo } from "react";
import z from "zod";
import { useUser } from "../../../api/hooks/useUser";
import { getMessageMediaApiUrl } from "../../../config/config";
import { useFetchData } from "../../../hooks/useFetchData";
import type { INTEGRATION_LIST } from "../components/constants";
import { WORKFLOWS_ABANDONED_CART } from "../featureList";

export type Integrations = (typeof INTEGRATION_LIST)[number];

const integrationZod = z.object({
  integration: z.string(),
  status: z.union([z.literal("INACTIVE"), z.literal("ACTIVE")]),
});

export type Integration = z.infer<typeof integrationZod>;

const MMFetchIntegrationURL = `${getMessageMediaApiUrl()}/int-bff/integrations/platform`;

export const useIntegration = (
  integration: Integrations,
  isEnabled: boolean
) => {
  const [user] = useUser();
  const hasIntegrationPermission = useMemo(
    () => user?.rights.includes(WORKFLOWS_ABANDONED_CART) || false,
    [user?.rights]
  );

  const parseIntegration = useCallback((data) => {
    const parsed = integrationZod.safeParse(data);
    if (parsed.success) return parsed.data;
    const errorMessage =
      "Invalid response from integrations/platform/:platform/status";
    console.warn(errorMessage, parsed.error);
    return data as Integration;
  }, []);

  return useFetchData(
    `${MMFetchIntegrationURL}/${integration}/status`,
    parseIntegration,
    {
      withToken: true,
      autoFetch: hasIntegrationPermission && isEnabled,
    }
  );
};
